import { TenantModel } from "../../model/data/tenant";

/**
 * Validates tenant form data
 * @param DATA - The tenant model data to validate
 * @param isEdit - Whether we're in edit mode (fewer required fields)
 * @returns Object with validation result and errors
 */
export const validateTenant = (DATA: TenantModel, isEdit: boolean = false) => {
  let valid = true;
  let errors: { name: string; error: string }[] = [];

  // Validate name
  if (!DATA.name?.trim()) {
    valid = false;
    errors.push({
      name: "name",
      error: "Tenant name is required",
    });
  }

  // Validate tenancy name
  if (!DATA.tenancyName?.trim()) {
    valid = false;
    errors.push({
      name: "tenancyName",
      error: "Tenancy name is required",
    });
  } else {
    // Allow only letters, numbers, and hyphens/underscores (no special chars or quotes)
    const tenancyNameRegex = /^[a-zA-Z0-9_-]+$/;
    if (!tenancyNameRegex.test(DATA.tenancyName)) {
      valid = false;
      errors.push({
        name: "tenancyName",
        error: "Tenancy name should not contain special characters or quotes",
      });
    }
  }

  // Validate status
  if (DATA.isActive === undefined || DATA.isActive === null) {
    valid = false;
    errors.push({
      name: "isActive",
      error: "Status selection is required",
    });
  }

  // Only validate default user fields when creating (not editing)
  if (!isEdit) {
    if (!DATA.defaultUser?.userName?.trim()) {
      valid = false;
      errors.push({
        name: "userName",
        error: "Default user name is required",
      });
    }

    if (!DATA.defaultUser?.emailAddress?.trim()) {
      valid = false;
      errors.push({
        name: "emailAddress",
        error: "Default user email is required",
      });
    } else if (!isValidEmail(DATA.defaultUser.emailAddress)) {
      valid = false;
      errors.push({
        name: "emailAddress",
        error: "Please enter a valid email address",
      });
    }

    // If connection string checkbox is selected, validate connection string
    if (DATA.connectionString && !DATA.connectionString?.trim()) {
      valid = false;
      errors.push({
        name: "connectionString",
        error: "Connection string is required when checkbox is selected",
      });
    }
  }

  return { valid, errors };
};

/**
 * Validates an email address
 * @param email - The email to validate
 * @returns Boolean indicating if email is valid
 */
function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}